import React from 'react';
import { useSelector } from 'react-redux';
import InputField from '../../../../../common/InputField';
import InputNumberField from '../../../../../common/InputNumberField';
import CommonCheckBox from '../../../../../common/CommonCheckBox';
import SelectOption from '../../../../../common/SelectOption';
import useInputValidator from '../../../../../../hooks/useInputValidator';
import TimeRangePicker from '../../../../../common/TimePickerWithHourly/TimeRangePicker';
import { Form, Row, Col, List } from 'antd';
// import { days } from '../../../../../common/constants';
import FieldName from '../../../../../common/FieldName';
import SateFullInputNumber from './Fields/SateFullInputNumber';
import Discount from '../../../../../common/Discounts';
import { useCallback } from '@storybook/addons';
import { useEffect, useState } from 'react';
import {
    addDiscountCount,
    addPackageCount,
    dailyPricingOptionValidation
} from '../../../../../../helper/spaceFormValidation';
import HourlyMinimumPicker from '../../../../../common/TimePickerWithHourly/HourlyMinimumPicker';

const HourlyPricingOption = ({paymentOptionIndex, paymentOptionId, form, currency, isEdit}) => {
  const { value, handleChange } = useInputValidator({
    minimumBookingPeriod: false,
    acceptedHalfHourBooking : false,
  });
  const formFields = isEdit ? form.getFieldValue() : null;
  const [selectedDays, setSelectedDays] = useState([]);
  const savings = useSelector((state) => state.space?.savings?.data || []);
  const [count, setCount] = useState([1])
  const days = useSelector((state)=>state.space?.pricingOptionsArray?.data?.filter(days=> days.chargingType==paymentOptionId)[0]?.pricingOptions || []);
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);
  const [bufferPeriodValue, setBufferPeriodValue] = useState(value?.acceptedHalfHourBooking ? 0.5 : 1)
  const [minimumBookingPeriod, setMinimumBookingPeriod] = useState(value?.acceptedHalfHourBooking ? 0.5 : 1);
  const {pricingOptionsArray} = useSelector((state)=> state.space || []);

  useEffect(() => {
    if(isEdit && pricingOptionsArray?.fetching){
        addDiscountCount(formFields?.chargings?.[0]?.discounts, setCount);
        const pricingOptions = formFields?.chargings?.[paymentOptionIndex]?.pricingOptions;
        pricingOptions && Object.entries(pricingOptions).forEach(
            ([key, data]) =>  {
                value[key] = []
                data.forEach(val => {
                    value.pricePerHour = val.pricePerHour;
                    value[key].push({ startTime: val.startTime, endTime: val.endTime });
                })
            }
        );
        formFields?.meetOrTrain?.hourlyPricingOption?.days && setSelectedDays(formFields?.meetOrTrain?.hourlyPricingOption?.days);
        formFields?.chargings?.[paymentOptionIndex]?.acceptedHalfHourBooking ? handleChange('acceptedHalfHourBooking',true):handleChange('acceptedHalfHourBooking',false);
    }
    return () => {
      setSelectedDays([])
      form.setFieldsValue({meetOrTrain: {hourlyPricingOption: {days : []}}})
    }
   },[formFields?.id]);

  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);

  const hours = [1, 2, 3, 4, 5, 6, 7, 8];

  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
  const validate = (rule, value) => {
    if (!value) {
      return Promise.reject('Please Fill Input Field!');
    }
    if (isNaN(value)) {
      return Promise.reject('Price must be Numbers');
    }
    return Promise.resolve();
  };
  const numberRule = [
    {
      required: true,
      validator: validate,
    },
  ];

  const setDays = (day) => {
    setSelectedDays([...selectedDays, day]);
    handleChange(day, [{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  };

  const deselectItems = (item) => {
    setSelectedDays(selectedDays.filter((i) => i !== item));
  };

  const handleAddDiscounts = () => {
    setCount([...count, (count[count.length - 1] + 1)]);
  }

  const handleRemoveDiscount = (selectedIndex) => {
    const copy = [...count];
    const stat = copy.filter((value, index) => { return index !== selectedIndex});

    setCount([...stat])
  }

  useEffect(()=> {
   let chargings =  form.getFieldValue(['chargings']);
   let chargingType =  form.getFieldValue(['chargings', paymentOptionIndex, 'chargingType', 'id']);

   if(!chargingType){
    if(!chargings) chargings = [];
    chargings = [...chargings, {
      chargingType: {
        id : paymentOptionId
      },
      acceptedHalfHourBooking: false,
      minimumBookingPeriodAvailability: true,
      minimumBookingPeriod: 1,
    }]
    form.setFieldsValue({
      chargings
    })
   }

 }, [])

  const handleMinimumBookingPeriodChange = (value) => {
    setMinimumBookingPeriod(value);
    setSelectedDays([])
    form.setFieldsValue({
      meetOrTrain: {
        hourlyPricingOption : {
          days : []
        }
      }
    })
  }

  return (
    <div  className="basic-details-wrapper">

      <Form.Item name={['chargings', paymentOptionIndex, 'chargingType', 'id']}>
      </Form.Item>
      <Form.Item name={['chargings', paymentOptionIndex, 'minimumBookingPeriodAvailability']}>
      </Form.Item>
      <h3>Hourly Price</h3>
      <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={['chargings', paymentOptionIndex, 'acceptedHalfHourBooking']}
            label={'Accept 0.5 Hour Booking'}
            handleOnChange={null}
            handleOnChange={(e) => handleChange('acceptedHalfHourBooking', e.target.checked)}
          />
        </Col>
      </Row>
        <InputNumberField
          name={['chargings', paymentOptionIndex, 'minimumBookingPeriod']}
          label={'Minimum Booking Period(hours)'}
          minAmount={value?.acceptedHalfHourBooking ? 0.5 : 1}
          value={minimumBookingPeriod}
          handleOnChange={handleMinimumBookingPeriodChange}
        />

      {count.map((number, index) => {
        return(
          <Discount
            key={number}
            savings={savings}
            labelPlaceHolder={'Discount applicable from'}
            hoursOrMonths={hours}
            paymentOptionIndex={paymentOptionIndex}
            handleAddDiscounts={handleAddDiscounts}
            handleRemoveDiscount={handleRemoveDiscount}
            index={index}
            values={number}
          />
        )
      })}

          <SateFullInputNumber label={'Buffer Period (Hours)'} name={'bufferPeriod'} fieldValue={bufferPeriodValue} setBufferPeriodValue={setBufferPeriodValue} changeAmount={value.acceptedHalfHourBooking ? 0.5 : 1}/>

      <SelectOption
        isMultiple={true}
        name={['meetOrTrain', 'hourlyPricingOption', 'days']}
        placeholder={'Days'}
        rules={rules}
        label={'Days'}
        values={days}
        handleOnSelect={setDays}
        handleOnDeselect={deselectItems}
        value={selectedDays}
      />

      {selectedDays.map((day) =>
        value[day] && value[day].length > 0 ? value?.[day].map((picker, index) => (
          <Form.Item label={day} name={['chargings', paymentOptionIndex, 'pricingOptions' , day, index]}>
            <HourlyMinimumPicker
              key={index}
              pickers={value[day]}
              setTimePicker={handleChange}
              index={index}
              day={day}
              isEdit={isEdit}
              step={value?.acceptedHalfHourBooking? 30 : 60}
              minimumBookingPeriod={minimumBookingPeriod}
            />
          </Form.Item>
        )) : null
      )}
    </div>
  );
};

export default HourlyPricingOption;
